import React, { useState, useEffect, useRef } from "react";
import Label from "components/general/Label"
import DateTime from "components/presentation/DateTime"
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import Noc from "components/presentation/Noc";
import Competitor from "components/presentation/Competitor";
import Status from "components/presentation/Status";
import {
    faCheck
} from "@fortawesome/free-solid-svg-icons";
import { usePrevious } from "./common"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function CompetitorBlock(competitor) {
    //console.log(competitor)
    let seed = ''
    let competitorBracket;
    if (competitor.co_seed) {
        seed = '(' + competitor.co_seed + ')'
    }
    if (competitor?.resultItem?.teamAthletes) {
        competitorBracket = <div className="w-85"><Competitor hidePicture={true} hideNoc={true} noLink={true} teamAthletes={competitor?.resultItem?.teamAthletes} seed={seed} small={true} /></div>
    } else {
        competitorBracket = <div className="w-85"><Competitor  {...competitor?.participant} hideNoc={true} hidePicture={true} noLink={true} seed={seed} small={true} /></div>
    }

    //Check if the game is singles or doubles

    return (
        <div className='score-competitor-container d-flex justify-content-start text-truncate'>
            {/*<div className='score-uniform score-uniform-home'></div>*/}
            <div className='score-noc'>
                <Noc className='me-1' {...competitor?.participant?.organisation} />
            </div>
            <div className='score-name d-flex align-items-center'>
                {competitorBracket}               
            </div>
        </div>
    )


}

export function Score(props) {
    const irm = props.showIRM && <span className="score-IRM"><strong>{props?.cp_irm}</strong></span>
    const resultItem = props?.resultItem;

    const g1 = props?.periods?.find(p => p?.p_code === 'G1');
    const g2 = props?.periods?.find(p => p?.p_code === 'G2');
    const g3 = props?.periods?.find(p => p?.p_code === 'G3');
    let resultG1
    let resultG2
    let resultG3
    if (g1 && props?.participant?.code === g1?.away?.participant?.code) {
        resultG1 = g1?.away?.periodScore ? `${g1?.away?.periodScore}` : '';
        resultG2 = g2?.away?.periodScore ? `${g2?.away?.periodScore}` : '';
        resultG3 = g3?.away?.periodScore ? `${g3?.away?.periodScore}` : '';
    } else if (g1) {
        resultG1 = g1?.home?.periodScore ? `${g1?.home?.periodScore}` : '';
        resultG2 = g2?.home?.periodScore ? `${g2?.home?.periodScore}` : '';
        resultG3 = g3?.home?.periodScore ? `${g3?.home?.periodScore}` : '';
    }

    /**
                   "sortOrder": 1,
                      "itemType": "T",
                      "bib": 0,
                      "resultType": "POINTS",
                      "resultRank": 0,
                      "resultIrm": "",
                      "resultWLT": " ",
                      "resultData": "45"
     */
    const winner = resultItem?.resultWLT === 'W' && <div className='score-winner'><FontAwesomeIcon className='' icon={faCheck} /></div>
    const [isLoading, setLoading] = useState(false);
    const result = resultItem?.resultData; //props.cp_result );
    const prevResult = usePrevious({ result });

    //console.log('COMPONENT PREV-USE: ' + prevResult)
    function loadingTime() {
        return new Promise((resolve) => setTimeout(resolve, 4000));
    }
    useEffect(() => {
        if (isLoading) {
            loadingTime().then(() => {
                setLoading(false);
            });
        }
    }, [isLoading]);


    useEffect(() => {
        if (prevResult && (prevResult !== result)) {
            setLoading(true)
        }

    }, [result])


    return (
        <>
            {result
                ? <div className='score-result-container d-flex flex-row justify-content-end align-self-center'>
                    <div className={`score-result text-end ${isLoading ? 'score-result-update' : ''}`}>
                        <span className="score-set"><strong>{result}</strong></span>
                        <span className="score-game">{resultG1}</span>
                        <span className="score-game">{resultG2}</span>
                        <span className="score-game">{resultG3}</span>
                        {irm}
                    </div>

                </div>
                : <div className='score-result-container  d-flex flex-row justify-content-end align-items-center'>
                    &nbsp;{irm}
                </div>
            }

        </>
    )
}

export function Footer({ data }) {
    const formatDate = Label({ data: 'BracketDateFormat' });
    const formatDateTime = Label({ data: 'BracketDateTimeFormat' });

    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} />, TDB</>
    const time = data?.bi_time && <DateTime datetime={dateTime} format={"HH:mm"} />
    const dateComponent = data?.bi_time ? dateTimeFormated : date
    let location = data?.schedule?.location?.shortDescription;
    let statusCode = data?.result?.status?.code

    return (
        <>
            {isLiveStatus(statusCode) &&
                <div className='score-status justify-content-end'>
                    <Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={statusCode} />
                </div>}

            <div className="d-flex">
                {isLessLiveStatus(statusCode) && <div className='text-start'>{dateComponent}</div>}
                {location && statusCode === 'START_LIST' && <div className='text-end'>{location}</div>}
            </div>
        </>
    )
}

export function CompetitorBlockNoData() {
    return ''
}


